import styled from 'styled-components';

export const SectionContainer = styled.div`
  margin-bottom: ${props => props.theme.space['2.0']};
`;
